export enum ButtonTypeEnum {
    SOLIDFILL,
    CLICKABLE_TEXT,
}
